import { combineReducers, configureStore } from '@reduxjs/toolkit';
// import userReducer from '../features/user/userSlice';

import formReducer from './Slices/formSlice';
import jdResponsesReducer from './Slices/jdResponsesSlices';
import tableSlice from './Slices/tableSlice';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

const reducers = combineReducers({
  form: formReducer,
  jdResponses: jdResponsesReducer,
  tableState: tableSlice
})

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['form', 'tableState', 'jdResponses'], // only persist the `form` reducer
};
const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
